import { Card } from "react-bootstrap";
import no_image from "../../../images/No_Image_Available.jpg";
import { setMobileTextColor } from "../../../utility";

const Section = ({
  section,
  handleParentSection,
  disabledFlag,
  handleSectionScroll,
  parentSectionName,
}) => {
  const onImageError = (e) => {
    e.target.src = no_image;
  };

  return (
    // <div
    //   ref={(el) => (disabledFlag == 1 ? handleSectionScroll(el) : true)}
    //   className={`col-md-12 m-auto mt-3 p-0`}
    // >
    //   <Card
    //     className={`${
    //       disabledFlag == 0
    //         ? `sections-sub-card rounded-4`
    //         : `sections-card rounded-4`
    //     }    m-auto d-flex justify-content-end align-items-center cursor`}
    //     onClick={() =>
    //       disabledFlag == 1 ? true : handleParentSection(section)
    //     }
    //   >
    //     {section ? (
    //       <Card.Img
    //         variant="top"
    //         src={section?.image}
    //         className="rounded-4 h-100 w-100"
    //         onError={onImageError}
    //       />
    //     ) : (
    //       <Card.Img
    //         variant="top"
    //         src={no_image}
    //         className="rounded-4 h-100 w-100"
    //         onError={onImageError}
    //       />
    //     )}
    //     <Card.Body
    //       className={`position-absolute w-100 rounded-4 ${
    //         disabledFlag == 0 ? `dark-bg-opacity-2` : ``
    //       }  h-100 d-flex align-items-center`}
    //       style={{
    //         borderBottomRightRadius: "2rem",
    //         borderBottomLeftRadius: "2rem",
    //       }}
    //     >
    //       {disabledFlag == 0 ? (
    //         <Card.Title className="font-size-24 text-center m-auto">
    //           <p
    //             style={{
    //               color: "#fff",
    //             }}
    //             className="mt-1 head-font text-shadw-border"
    //           >
    //             <p>{section.name}</p>
    //           </p>
    //         </Card.Title>
    //       ) : (
    //         ""
    //       )}
    //     </Card.Body>
    //   </Card>
    //   {disabledFlag == 1 ? (
    //     <>
    //       <Card.Title className="font-size-24 text-center m-auto">
    //         <p
    //           style={{
    //             color: setMobileTextColor(),
    //           }}
    //           className="mt-1 head-font"
    //         >
    //           <p>{section.name}</p>
    //         </p>
    //       </Card.Title>
    //       <Card.Title className="font-size-20 text-center">
    //         <span
    //           style={{
    //             color: setMobileTextColor(),
    //           }}
    //           className="mt-0 sub-font"
    //         >
    //           {section.description || ""}
    //         </span>
    //       </Card.Title>
    //     </>
    //   ) : (
    //     ""
    //   )}
    // </div>

    <div
      ref={(el) => (disabledFlag == 1 ? handleSectionScroll(el) : null)}
      className={`${parentSectionName ? 'col-6' : 'col-12'
        } mt-3 px-2`}
    >
      <Card
        className={`${disabledFlag == 0
          ? 'sections-sub-card'
          : 'sections-card'
          } rounded-4 shadow-sm position-relative overflow-hidden cursor-pointer`}
        style={{
          height: parentSectionName ? '180px' : '240px', // shorter height when parent exists
          margin: '0 auto',
          border: '1px solid #e0e0e0',
        }}
        onClick={() => (disabledFlag == 1 ? null : handleParentSection(section))}
      >
        <Card.Img
          variant="top"
          src={section?.image || no_image}
          className="w-100 h-100 object-fit-cover"
          onError={onImageError}
        />

        {/* Overlay content */}
        <Card.Body
          className={`position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-2 ${disabledFlag == 0 ? 'bg-dark bg-opacity-50' : ''
            }`}
        >
          {disabledFlag == 0 && (
            <Card.Title className="text-center m-0">
              <p className="head-font text-white text-shadow mb-0">
                {section?.name}
              </p>
            </Card.Title>
          )}
        </Card.Body>
      </Card>

      {/* Extra content below for disabledFlag == 1 */}
      {disabledFlag == 1 && (
        <div className="text-center mt-2">
          <Card.Title className="font-size-20 head-font" style={{ color: setMobileTextColor() }}>
            {section.name}
          </Card.Title>
          <Card.Text className="font-size-16 sub-font" style={{ color: setMobileTextColor() }}>
            {section.description || ''}
          </Card.Text>
        </div>
      )}
    </div>

  );
};

export default Section;
